// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__ZeWWc","label":"Checkbox_label__G-KsE","icon":"Checkbox_icon__3irIM"};